import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Card } from 'antd';
import { PermissionsListCardInfo } from './mapAdminToPermissionsList';

export const avatarText = (text: string) => {
  let initial = text;

  if (text.includes('(')) {
    // eslint-disable-next-line prefer-destructuring
    initial = text.split('(')[0];
  }
  return initial
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};

export const PermissionsListLinkCard = ({
  title,
  description,
  cardLink,
  adminRoles,
}: Partial<PermissionsListCardInfo>): ReactElement => {
  const { Meta } = Card;

  const handleAvatarGroup = (roles) => {
    if (roles.length === 0) {
      return (
        <Avatar size={15} style={{ visibility: 'hidden' }}>
          {' '}
        </Avatar>
      );
    }
    const avatars = roles.map((role) => (
      <Avatar key={`${title}-${role}`} size={50}>
        {avatarText(role)}
      </Avatar>
    ));
    return (
      <Avatar.Group maxCount={2} size={50}>
        {avatars}
      </Avatar.Group>
    );
  };

  const avatar = handleAvatarGroup(adminRoles);

  return (
    <Link to={cardLink} style={{ width: '100%' }}>
      <Card bodyStyle={{ padding: 16 }}>
        <Meta avatar={avatar} title={title} description={description} />
      </Card>
    </Link>
  );
};
